import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CupraCareModel } from '../../../../models/cupracare';
import { CupraCalculatorService } from '../../../../services/cupracalculator.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cupra-care',
  templateUrl: './cupra-care.component.html',
  styleUrls: ['./cupra-care.component.scss']
})

export class CupraCareComponent implements OnInit {

  @Input() IdBudget: string;
  model: CupraCareModel;

  constructor(private service: CupraCalculatorService, private router: Router,private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getCupraCarePrice();
  }

  getCupraCarePrice() {
    this.service.getCupraCareFromBudget(this.IdBudget).subscribe(resp => {      
      this.model = resp;
    });
  }

  contract() {
    this.router.navigate(["/cupra-care/" + this.IdBudget]);
  }

  openVerticallyCentered(content) {
    this.modalService.open(content, { centered: true,  size: 'lg' });
  }

}
